import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

export const getHeaderThemeColor = (
  timesheetStatus: TimesheetStatus,
  isManager: boolean
): ThemeColorType => {
  if (isManager && timesheetStatus === TimesheetStatus.pending) {
    return ThemeColorType.warning;
  }

  return ThemeColorType.primary;
};
